export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/pcln-hp-hero-hotels-70dea08597eb07f42fb8ecf054db24be.jpg";